<template>
    <div class="product-carousel" >
        <div class="carousel-container">
            <div class="carousel-wrapper">
                <div class="carousel-track" v-for="(item, index) in visibleItems" :key="item.realIndex" :class="getItemClass(index)" :style="getItemStyle(index)">
                    <div class="carousel-item" 
                        @click="handleItemClick(index)">
                        <img :src="item.image" :alt="'Product ' + (item.realIndex + 1)">
                       
                    </div>
                     <div class="product-info" :style="{ color: item.color }">
                            {{ item.name }}
                        </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductList',
    data() {
        return {
            currentIndex: 0,
            images: [{
                pic: 'https://cdn.magicmart.vip/website/assets/product/product1.png',
                name: '苏丹的游戏 第六弹',
                color: "#FDEE8D"
            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product2.png',
                name: '苏丹的游戏 第六弹',
                color: "#FDEE8D"

            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product3.png',
                name: '苏丹的游戏',
                color: "#FDEE8D"

            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product4.png',
                name: '苏丹的游戏',
                color: "#FDEE8D"

            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product5.png',
                name: '囚于永夜 抽拉团子',
                color: "#F9EEE1"
            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product6.png',
                name: '魔道祖师',
                color: "#8FC7BF"
            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product7.png',
                name: '谷围南亭 第三弹',
                color: "#B8D3CB"
            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product8.png',
                name: '谷围南亭 第二弹',
                color: "#B8D3CB"
            }, {
                pic: 'https://cdn.magicmart.vip/website/assets/product/product9.png',
                name: '苏丹的游戏',
                color: "#FDEE8D"
            }],
            autoPlayInterval: null,
            isTransitioning: false,
            visibleCount: 5
        }
    },
    computed: {
        centerIndex() {
            return Math.floor(this.visibleCount / 2)
        },
        visibleItems() {
            const items = []
            const totalItems = this.images.length

            for (let i = 0; i < this.visibleCount; i++) {
                let index = (this.currentIndex + i - this.centerIndex) % totalItems
                if (index < 0) {
                    index += totalItems
                }
                items.push({
                    image: this.images[index].pic,
                    realIndex: index,
                    name: this.images[index].name,
                    color: this.images[index].color
                })
            }

            return items
        }
    },
    mounted() {
        this.startAutoPlay()
    },
    beforeDestroy() {
        this.stopAutoPlay()
    },
    methods: {
        getItemClass(index) {
            return {
                'center': index === this.centerIndex,
                'side': index === this.centerIndex - 1 || index === this.centerIndex + 1,
                'edge': index === 0 || index === this.visibleCount - 1
            }
        },
        getItemStyle(index) {
            const offset = index - this.centerIndex
            const spacingVw = index === this.centerIndex ? 0 : (index === this.centerIndex - 1 || index === this.centerIndex + 1 ? 25 * offset : 24 * offset)
            const scale = index === this.centerIndex ? 1 : 0.8
            const opacity = index === this.centerIndex ? 1 : (index === this.centerIndex - 1 || index === this.centerIndex + 1 ? 0.8 : 0.5)
            const zIndex = index === this.centerIndex ? 3 : (index === this.centerIndex - 1 || index === this.centerIndex + 1 ? 2 : 1)
            return {
                transform: `translateX(${spacingVw}vw) scale(${scale})`,
                opacity,
                zIndex
            }
        },
        nextSlide() {
            if (this.isTransitioning) return
            this.isTransitioning = true
            this.currentIndex = (this.currentIndex + 1) % this.images.length
            this.resetAutoPlay()
            setTimeout(() => {
                this.isTransitioning = false
            }, 300)
        },
        prevSlide() {
            if (this.isTransitioning) return
            this.isTransitioning = true
            this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length
            this.resetAutoPlay()
            setTimeout(() => {
                this.isTransitioning = false
            }, 300)
        },
        handleItemClick(index) {
            if (index === this.centerIndex) {
                return
            }
            if (index < this.centerIndex) {
                this.prevSlide()
            } else {
                this.nextSlide()
            }
        },
        startAutoPlay() {
            this.autoPlayInterval = setInterval(() => {
                this.nextSlide()
            }, 3000)
        },
        stopAutoPlay() {
            if (this.autoPlayInterval) {
                clearInterval(this.autoPlayInterval)
                this.autoPlayInterval = null
            }
        },
        resetAutoPlay() {
            this.stopAutoPlay()
            this.startAutoPlay()
        }
    }
}
</script>

<style scoped>
.product-carousel {
    width: 100%;
    height: 1000px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(https://cdn.magicmart.vip/website/assets/product/productBack.png);
    background-size: 100%;
    background-repeat: no-repeat;
    overflow: hidden;
}

.carousel-container {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;
}

.carousel-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.carousel-track{
    position: absolute;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform, opacity;
}

.carousel-item {
    width: 444px;
    height: 585px;
}

.carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.product-info {
    font-weight: 600;
    font-size: 30px;
    text-align: center;
    margin-top: 43px;
}
</style>
